import { Provider } from '@angular/core';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE, MAT_NATIVE_DATE_FORMATS } from '@angular/material/core';
import { MngGermanDateAdapter } from './mng-german-date-adapter.service';

export const providersForDate: Provider[] = [
  { provide: MAT_DATE_LOCALE, useValue: 'de-DE' },
  { provide: DateAdapter, useClass: MngGermanDateAdapter },
  { provide: MAT_DATE_FORMATS, useValue: MAT_NATIVE_DATE_FORMATS }
];
